import axios from 'axios';
import { ParamsType, QRcodeType, DEFAULT_API_TIMEOUT, AZIR_CONFIG } from './data';

const DEFAULT_CONFIG = {
  timeout: DEFAULT_API_TIMEOUT,
  headers: { 'Content-Type': 'application/json' }
}

// 开发环境用相对路径，与页面同源（用 IP 打开时请求也走同一 host，由 devServer proxy 转发，避免跨域）
const baseURL =
  process.env.NODE_ENV === 'development' ? '' : `//${process.env.REACT_APP_API_URL}`;

const instance = axios.create({
  baseURL,
  ...DEFAULT_CONFIG
});

export async function getPackageById(version: string) {
  const res = await instance.get(`/api/package/${version}`);
  return res.data;
}

export async function getHistory(params: ParamsType) {
  const res = await instance.post('/api/history', params);
  return res.data;
}

export async function getQRcode(params: QRcodeType) {
  const res = await instance.post('/api/qrcode', params);
  return res.data;
}

export async function getLatestVersion(versionType: string, productSort?: string) {
  const params = productSort ? { product_sort: productSort } : {};
  const res = await instance.get(`/api/latest/${versionType}`, { params });
  return res.data;
}

export async function getAzirConfig() {
  const res = await instance.get(`/api/azir-config/get`, {
    params: { name: AZIR_CONFIG.IOS_TF_URL },
  });
  return res.data;
}
